export default "__VITE_ASSET__71cd0619__"